import axios from 'axios'
import { getAccessToken } from '@/utils/auth'
import { handleAxiosPromise } from '@/utils/api-common'

const BASE_URL = process.env.BOOLEAN2D_SERVER
const queryUrl = `${BASE_URL}/api/query`
const queryUrlPublic = `${BASE_URL}/api/query-public`
const logUrl = `${BASE_URL}/api/log`

export { getQueries, countQueries, getQuery, getQueryPublic, createQuery, createQueries, updateQuery, deleteQuery, simpleLog }

function config () {
  return { headers: { Authorization: `Bearer ${getAccessToken()}` } }
}

function getQueries () {
  return handleAxiosPromise(axios.get(queryUrl, config()))
}

function countQueries () {
  return handleAxiosPromise(axios.get(queryUrl + '/count', config()))
}

function getQuery (id) {
  return handleAxiosPromise(axios.get(queryUrl + '/' + id, config()))
}

function getQueryPublic (id) {
  return handleAxiosPromise(axios.get(queryUrlPublic + '/' + id, config()))
}

function createQuery (query) {
  return handleAxiosPromise(axios.post(queryUrl, query, config()))
}

function updateQuery (query) {
  return handleAxiosPromise(axios.put(queryUrl, query, config()))
}

function deleteQuery (id) {
  return handleAxiosPromise(axios.delete(queryUrl + '/' + id, config()))
}

function createQueries (queries) {
  return Promise.all(queries.map(q => {
    return axios.post(queryUrl, q, config())
  })).then(rs => {
    return rs
  })
}

function simpleLog (message) {
  return handleAxiosPromise(axios.post(logUrl, message, config()))
}



// WEBPACK FOOTER //
// ./src/utils/queries-api.js